// Defaults based on iPhone 5
export var DEFAULT_VIEWPORT_HEIGHT = 1136;
export var DEFAULT_VIEWPORT_WIDTH = 640;